'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _LayoutParserUtils = require('./_LayoutParserUtils');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LayoutParser = function LayoutParser() {
  return {
    parsePageLayout: function parsePageLayout(sectionTypes, componentData) {
      // Get section layouts from all section types
      var sections = (0, _LayoutParserUtils.getSections)(sectionTypes);

      // Get defined sections (a section that has a defined layout)
      var definedSections = sections.map(function (section) {
        // if the section is not a react element
        if (Object.keys(section).indexOf('$$typeof') === -1) {
          var layouts = section.layouts,
              rest = _objectWithoutProperties(section, ['layouts']);

          // If there are layouts for the section


          if (layouts.length > 0) {
            // Get types of defined components for all layouts in this section
            var definedSectionComponentTypes = (0, _LayoutParserUtils.getDefinedSectionComponentTypes)(layouts, componentData);

            // Match the layout the best fits the defined components for this section
            // Best fit is based off layout with most defined content
            var matchedSectionLayout = (0, _LayoutParserUtils.matchComponentsToSectionLayout)(definedSectionComponentTypes, layouts);

            // Wrap all components for this section layout with their property values
            var componentsWithProps = matchedSectionLayout ? (0, _LayoutParserUtils.createComponentsWithProps)(matchedSectionLayout, componentData) : false;

            // Return false if there were no properties because no matched layout for section
            if (!componentsWithProps) return false;

            return _extends({}, rest, {
              sectionLayout: _extends({}, matchedSectionLayout, {
                components: componentsWithProps
              })
            });
          }
          // No layouts for the section
          return false;
        }
        return section;
      });

      // Remove sections that do not have a defined layout
      return (0, _LayoutParserUtils.removeUndefinedValuesFromList)(definedSections);
    },
    getChildComponent: function getChildComponent(components, componentName) {
      var chosenComponent = components.filter(function (component) {
        return component.type === componentName;
      })[0];
      return chosenComponent.component;
    },
    createLayoutColumnProps: function createLayoutColumnProps(props) {
      var desktopWidth = props.desktopWidth,
          tabletWidth = props.tabletWidth,
          mobileWidth = props.mobileWidth,
          verticalAlign = props.verticalAlign,
          horizontalAlign = props.horizontalAlign;

      return {
        computer: desktopWidth,
        tablet: tabletWidth,
        mobile: mobileWidth,
        textAlign: horizontalAlign,
        verticalAlign: verticalAlign
      };
    }
  };
};

exports.default = LayoutParser;